<template>
    <ul class="filter filter--letters">
        <template v-for="item in items">
            <li class="filter--letters__item" :class="item === value ? 'active' : ''">
                <button role="button" :title="item" @click="onClickItem(item)">{{ item }}</button>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        props : {
            items : {
                type : Array,
                default : () => ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
            },
            value : {
                type : String,
                default : ''
            }
        },
        methods : {
            onClickItem : function (letter) {
                if (this.value === letter) {
                    this.value = '';
                } else {
                    this.value = letter;
                }

                this.$emit('onClickItem', this.value);
            }
        }
    }
</script>